var useProgress = () => {
  var handleProgress = progress => Math.max(0, Math.min(progress, 100));

  var handleStrokeDasharray = (progress, strokeDasharray) => strokeDasharray - handleProgress(progress) * strokeDasharray / 100;

  return {
    handleProgress,
    handleStrokeDasharray
  };
};

export { useProgress };
//# sourceMappingURL=useProgress.js.map